import { NavLink, Outlet, Navigate } from "react-router-dom";
import { BarChart3, Building2, Users, RotateCcw, LogOut, Gift, Receipt, Wallet, Mail, Search, Flag } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/admin", label: "Analytics", icon: BarChart3, end: true },
  { to: "/admin/businesses", label: "Businesses", icon: Building2 },
  { to: "/admin/invoices", label: "Invoices", icon: Receipt },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/emails", label: "Sent emails", icon: Mail },
  { to: "/admin/refunds", label: "Refund disputes", icon: RotateCcw },
  { to: "/admin/reports", label: "Reported reviews", icon: Flag },
  { to: "/admin/gift-card-payouts", label: "Gift card payouts", icon: Gift },
  { to: "/admin/wallets", label: "Wallets", icon: Wallet },
  { to: "/admin/search", label: "Search", icon: Search },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login?next=/admin" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 px-4 py-4 sm:gap-8 sm:px-6 sm:py-8 md:grid-cols-[220px_1fr]">
      <nav className="-mx-4 flex gap-1 overflow-x-auto border-b border-border px-4 pb-2 sm:mx-0 sm:flex-col sm:overflow-visible sm:border-0 sm:px-0 sm:pb-0 sm:space-y-1">
        <p className="mb-3 hidden px-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground sm:block">
          Admin
        </p>
        {links.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium whitespace-nowrap ${
                isActive ? "bg-primary/10 text-primary" : "text-slate-600 hover:bg-muted"
              }`
            }
          >
            <Icon className="h-4 w-4" /> {label}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={logout}
          className="flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium text-slate-600 hover:bg-muted whitespace-nowrap sm:w-full"
        >
          <LogOut className="h-4 w-4" /> Log out
        </button>
      </nav>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
